import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
    title: {
        marginTop: '40px',
        marginBottom: theme.spacing(3)
    },
    notifications: {
        marginTop: '20px',

    },
    select: {
        '& fieldset': {
            borderColor: '#d8d6d6',
            borderWidth: 2,
        },
    },
}))

export default styles;